import React from "react";
import { useSelector } from "react-redux";

import { Slider, Rail, Handles, Tracks } from "react-compound-slider";
import { Handle, SliderRail, Track } from "../components/SliderComponents";

export default function TravelTimesFilter(props) {
  const { changeFilterAndSearch } = props;

  const loading = useSelector((state) => state.system.loading);
  const outboundtime = useSelector((state) => state.search.outboundtime);
  const inboundtime = useSelector((state) => state.search.inboundtime);

  React.useEffect(() => {
    setOutboundTime(outboundtime);
  }, [outboundtime]);

  React.useEffect(() => {
    setInboundTime(inboundtime);
  }, [inboundtime]);

  const domain = [0, 23];
  const [inboundTime, setInboundTime] = React.useState("0-23");
  const [outboundTime, setOutboundTime] = React.useState("0-23");

  const sliderStyle = {
    position: "relative",
    width: "100%",
  };

  //console.log(outboundTime);

  return (
    <div
      className="traveltimesfilter"
      style={{
        border: "1px solid #d0d0d0",
        backgroundColor: "white",
        marginBottom: 16,
        marginTop: 16,
        padding: 16,
      }}
    >
      <span className="traveltimesfilter1 filterheader">Hinflug-Zeiten</span>
      <br />
      {outboundTime.split("-")[0]}:00 - {outboundTime.split("-")[1]}:59 Uhr
      <br />
      <br />
      <Slider
        mode={2}
        step={1}
        domain={domain}
        disabled={loading > 0}
        className="slider-root"
        rootStyle={sliderStyle}
        onChange={(val) => {
          //console.log("c", val);
          if (outboundtime !== outboundTime)
            changeFilterAndSearch("outboundtime", val.join("-"));
        }}
        onUpdate={(val) => {
          //console.log("u", val);
          setOutboundTime(val.join("-"));
        }}
        values={outboundtime.split("-")}
      >
        <Rail>
          {({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}
        </Rail>
        <Handles>
          {({ handles, getHandleProps }) => (
            <div className="slider-handles">
              {handles.map((handle) => (
                <Handle
                  key={handle.id}
                  handle={handle}
                  domain={domain}
                  getHandleProps={getHandleProps}
                />
              ))}
            </div>
          )}
        </Handles>
        <Tracks left={false} right={false}>
          {({ tracks, getTrackProps }) => (
            <div className="slider-tracks">
              {tracks.map(({ id, source, target }) => (
                <Track
                  key={id}
                  source={source}
                  target={target}
                  getTrackProps={getTrackProps}
                />
              ))}
            </div>
          )}
        </Tracks>{" "}
      </Slider>
      <br />
      <br />
      <span className="traveltimesfilter2 filterheader">Rückflug-Zeiten</span>
      <br />
      {inboundTime.split("-")[0]}:00 - {inboundTime.split("-")[1]}:59 Uhr
      <br />
      <br />
      <Slider
        mode={2}
        step={1}
        domain={domain}
        disabled={loading > 0}
        rootStyle={sliderStyle}
        className="slider-root"
        onChange={(val) => {
          //console.log("c", val);
          if (inboundtime !== inboundTime)
            changeFilterAndSearch("inboundtime", val.join("-"));
        }}
        onUpdate={(val) => {
          //console.log("u", val);
          setInboundTime(val.join("-"));
        }}
        values={inboundtime.split("-")}
      >
        <Rail>
          {({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}
        </Rail>
        <Handles>
          {({ handles, getHandleProps }) => (
            <div className="slider-handles">
              {handles.map((handle) => (
                <Handle
                  key={handle.id}
                  handle={handle}
                  domain={domain}
                  getHandleProps={getHandleProps}
                />
              ))}
            </div>
          )}
        </Handles>
        <Tracks left={false} right={false}>
          {({ tracks, getTrackProps }) => (
            <div className="slider-tracks">
              {tracks.map(({ id, source, target }) => (
                <Track
                  style={{ backgroundColor: "red" }}
                  key={id}
                  source={source}
                  target={target}
                  getTrackProps={getTrackProps}
                />
              ))}
            </div>
          )}
        </Tracks>{" "}
      </Slider>
      <br />
      <br />
    </div>
  );
}
